import { render, staticRenderFns } from "./ruleClass.vue?vue&type=template&id=5204d648&scoped=true&"
import script from "./ruleClass.vue?vue&type=script&lang=js&"
export * from "./ruleClass.vue?vue&type=script&lang=js&"
import style0 from "./ruleClass.vue?vue&type=style&index=0&id=5204d648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204d648",
  null
  
)

export default component.exports